<!--
bool-checkbox
用例：
<bool-checkbox v-model="isNormalUser">普通</bool-checkbox>

//-->
<template>
  <div class="bool-checkbox-component">
    <el-checkbox :value="value"></el-checkbox>
    <div class="click-box" @click="_toggleItem"></div>
    <label class="checkbox-text">{{ text }}<slot></slot></label>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'value',
    event: 'changed'
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {}
  },
  computed: {
    iconClassName() {
      let classNames = this.value ? 'checkbox-icon-selected' : 'checkbox-icon-unselected'
      if (this.disabled) {
        classNames = classNames + ' checkbox-disabled'
      }
      return classNames
    }
  },
  methods: {
    // events
    _triggerChangedEvent() {
      this.$emit('changed', !this.value)
    },
    _toggleItem() {
      if (this.disabled) return

      this._triggerChangedEvent()
    }
  }
}
</script>

<style lang="scss" scoped>
.bool-checkbox-component {
  cursor: pointer;
  display: inline-block;
  line-height: 20px;
  position: relative;
  .click-box {
    z-index: 99;
    position: absolute;
    top: 3px;
    left: 0;
    width: 14px;
    height: 14px;
    background: transparent;
  }

  .checkbox-icon {
    width: 15px;
    height: 15px;
    display: inline-block;
    background-repeat: no-repeat;
    vertical-align: middle;
    margin-top: 3px;
  }
  .checkbox-icon-unselected {
    background-image: url('/images/icons/checkbox_unselected.svg');
  }
  .checkbox-icon-selected {
    background-image: url('/images/icons/checkbox_selected.svg');
  }
  .checkbox-disabled {
    cursor: not-allowed;
    filter: grayscale(80%);
  }

  .checkbox-text {
    line-height: 20px;
    margin: 0px;
    margin-left: 2px;
    vertical-align: middle;
  }
}
</style>
